import React, { useState } from 'react';
import { CButton, CDropDown, CTags } from '../../UI';
import { useLocaleContext } from '../../../context/LocaleContext';

import './style.scss';

const FiltersTags = ({tags, selectedTags, onChange, onReset}) => {
    const $locale = useLocaleContext();
    const [isListOpen, setListOpen] = useState(false);

    return (
        <div className="filter-tags-container">
            {
                (!!selectedTags.length && !isListOpen) &&
                <CButton
                    blank
                    icon="close"
                    onClick={onReset}
                />
            }
            <CDropDown
                trigger={<CButton
                    blank
                    label={$locale.get('label.tags')}
                    iconPosition="right"
                    icon="arrow_down"
                />}
                maxWidth={600}
                onOpen={setListOpen}
            >
                <CTags
                    clickable
                    tags={tags}
                    selectedTags={selectedTags}
                    className="filter-tags"
                    onChange={onChange}
                    onReset={onReset}
                />
            </CDropDown>
        </div>
    );
};

export default FiltersTags;
